import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { api } from "@/services/apis/api.ts";
import authenticationSliceReducer from "@/app/Authentication.slice";
import uiStateSliceReducer from "@/features/UiState.slice";

/**
 * The slices both builds need: the customer app's store and the admin's.
 *
 * A function rather than a module-level object so each store gets its own
 * persisted reducers, and a module of its own so importing it creates no
 * store. The workspace slice is not here: only the customer app has a
 * selected workspace.
 */
export const createSharedReducers = () => ({
    [api.reducerPath]: api.reducer,
    uiState: persistReducer({ key: "uiState", storage }, uiStateSliceReducer),
    authentication: authenticationSliceReducer,
});
